import type { FC, ReactNode } from 'react'

import { event, travelOptions } from '@/constants/metric'
import { ActionButton } from '@/components/generals/action-button'
import { SectionHeading } from '@/components/generals/section-heading'

const MAP_SRC = 'https://www.google.com/maps?q=Station+Berlin+Luckenwalder+Strasse+4-6+Berlin&z=15&output=embed'

export const LocationSection: FC = (): ReactNode => {
    return (
        <section id='location' aria-labelledby='location-title' className='scroll-mt-[96px] px-0 py-20 tab:px-[60px] tab:py-28'>
            <div className='fw-container flex flex-col items-center gap-12 tab:gap-16'>
                <SectionHeading
                    tag='Location'
                    title={<span id='location-title'>{event.venue}</span>}
                    description='A converted rail depot in Kreuzberg, four minutes from Gleisdreieck, with three halls under one very large roof.'
                />

                <div
                    data-reveal='up'
                    className='relative aspect-[16/9] w-full overflow-hidden rounded-[9px] border border-line bg-surface sm:aspect-[21/9]'
                >
                    <iframe
                        title={`Map showing ${event.venue}`}
                        src={MAP_SRC}
                        loading='lazy'
                        referrerPolicy='no-referrer-when-downgrade'
                        className='absolute inset-0 h-full w-full border-0 opacity-90 [filter:invert(1)_hue-rotate(180deg)_saturate(0.25)_brightness(0.92)_contrast(1.05)]'
                    />

                    <span aria-hidden='true' className='pointer-events-none absolute inset-0 bg-[#0d0d0d]/10' />
                </div>

                <ul className='grid w-full grid-cols-1 gap-5 sm:grid-cols-3'>
                    {travelOptions.map((option, index) => (
                        <li
                            key={option.title}
                            data-reveal='up'
                            data-reveal-delay={0.08 * index}
                            className='flex h-full flex-col gap-4 rounded-[9px] border border-line bg-[#0d0d0d] p-6 transition-colors duration-500 hover:border-[#454545]'
                        >
                            <h3 className='font-sans text-[22px] font-medium leading-[1.2em] text-ink'>
                                {option.title}
                            </h3>

                            <p className='flex-1 font-body text-[16px] leading-[1.4em] text-ink-soft'>
                                {option.copy}
                            </p>

                            <ActionButton href={option.href} variant='outline' size='sm' className='w-fit'>
                                {option.cta}
                            </ActionButton>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
